import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {ClaimDto} from "../../../../auto-generated-server-dtos/claim/claim-dto";
import {SetManuallyEnteredDeductibleService} from "./services/set-manually-entered-deductible.service";
import {debounceTime, distinctUntilChanged, Subject, switchMap} from "rxjs";

@Component({
  selector: 'app-deductible',
  templateUrl: './deductible.component.html',
  styleUrl: './deductible.component.scss'
})
export class DeductibleComponent implements OnInit, OnChanges {
  @Input() claimDto!: ClaimDto;
  @Input() minimalUi: boolean = false;
  @Input() manuallyEnteredDeductible: number | null | undefined = null;
  @Output() manuallyEnteredDeductibleChanged = new EventEmitter<number | null | undefined>();

  private manuallyEnteredDeductible$ = new Subject<number | null | undefined>();

  constructor(private setManuallyEnteredDeductibleService: SetManuallyEnteredDeductibleService) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.manuallyEnteredDeductible) {
      this.manuallyEnteredDeductibleChanged.emit(this.claimDto.manuallyEnteredDeductible);
    }
  }

  setManuallyEnteredDeductible() {
    this.setManuallyEnteredDeductibleService.setManuallyEnteredDeductible(this.claimDto.claimId, this.claimDto.manuallyEnteredDeductible).subscribe();
  }

  ngOnInit(): void {
    this.manuallyEnteredDeductible$.pipe(
      debounceTime(500),
      distinctUntilChanged(),
      switchMap((manuallyEnteredDeductible) =>
        this.setManuallyEnteredDeductibleService.setManuallyEnteredDeductible(this.claimDto.claimId, manuallyEnteredDeductible)
      )
    ).subscribe();
  }

  debounceUpdateManuallyEnteredDeductible() {
    this.manuallyEnteredDeductible$.next(this.claimDto.manuallyEnteredDeductible);
  }
}
